export interface CustomViewFolder {
  id: string;
  name: string;
  parentId: string | null;
  isFavorite: boolean;
  isDefault: boolean;
  createdOn: Date | string;
  category: ViewCategory;
  children?: CustomViewFolder[];
  isExpanded: boolean;
  folderType?: FolderType;
  temporaryViewID: string | null;
}

export enum ViewCategory {
  Folder,
  SystemView,
  UserView,
  SharedView,
  SharedWithMe,
}

export enum FolderType {
  User,
  Shared,
  System,
  SharedWithMe,
}

export interface TreeNodeDetails {
  id: any;
  name: string;
  shortPath: string;
  fullPath: string;
  action: string;
  folderType: string;
}

export interface viewFolderItem {
  id: string;
  children: Array<Object> | null;
}
